<template>
  <div
    class="left-menu"
    :class="{ hidden }"
  >
    <div
      :class="mobile ? '' : 'menu-content position-fixed'"
    >
      <div
        v-if="!mobile"
        class="d-flex justify-content-center"
      >
        <div
          class="logo-container text-center"
          @click="showAll"
        >
          <img
            src="@/assets/p_blue.png"
            class="logo"
          >
        </div>
      </div>
      <div
        style="margin: 10px auto"
        :class="mobile ? 'd-flex align-items-center justify-content-around no-gutters mobile-menu' : ''"
      >
        <div
          v-for="el in list"
          :key="el.name"
          :class="mobile ? 'py-1' : ''"
          style="width: 65px"
        >
          <RouterLink
            class="text-center menu-tab d-flex flex-column justify-content-center mx-auto"
            :class="{ 'active': page === el.name }"
            :data-test="el.dataTest"
            :to="`/payer/${el.name}`"
          >
            <span
              v-if="el.name === 'messages' && userUnreadCount"
              class="badge badge-pill float-right badge-danger message-count"
            >{{ userUnreadCount }}</span>
            <i :class="el.icon" />
            <div
              class="menu-text"
            >
              {{ el.text }}
            </div>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    page: String,
    mobile: Boolean,
    hidden: Boolean,
  },
  computed: {
    ...mapGetters(['payeeId', 'userUnreadCount']),
    list() {
      return [
        {
          name: 'home',
          text: this.$t('menu.home'),
          icon: 'far fa-house',
        },
        {
          name: 'shop',
          text: this.$t('menu.shop'),
          icon: 'far fa-basket-shopping',
        },
        {
          name: 'messages',
          text: this.$t('menu.messages'),
          icon: 'far fa-comments',
        },
      ];
    },
  },
  methods: {
    showAll() {
      this.$router.push('/?stay=true');
    },
  },
};
</script>

<style lang="scss" scoped>

  .btn {
    border-radius: 20px;
  }
  .message-count {
    cursor: pointer;
    margin-bottom: -20px;
    margin-right: 5px;
    position: absolute;
    top: 0;
    right: 0;
  }

  .logo-container {
    cursor: pointer;
    height: 60px;
    width: 60px;
    border-radius: 50%;
    padding: 15px 8px;

    &:hover {
      color: white;
    }

    &:hover img {
      opacity: 1;
    }
  }

  .logo {
    width: 100%;
    opacity: 1;
  }

  .menu-tab {
    line-height: 1;
    cursor: pointer;
    color: #919191;
    margin: 0 3px 2px;
    position: relative;
    text-decoration: none;
    border-radius: 20px;
    height: 72px;
    width: 72px;
    transition: background-color 100ms;

    &:hover {
      color: #333;
    }

    &.active {
      color: $blue;
      background-color: rgba(#fff, 0.2);
    }

    i {
      font-size: 1.6rem;
    }
  }

  .left-menu {
    width: 80px;
    max-width: 80px;
    position: relative;
    transition: left 500ms, width 500ms;

    .menu-content {
      left: 1rem;
      height: 100vh;
      width: 80px;
      max-width: 80px;
      z-index: 100;
      transition: left 500ms;
    }

    &.hidden {
      left: -80px;
      width: 0px;

      > .menu-content {
        left: -80px;
      }
    }
  }

  .menu-text {
    font-size: 11px;
    line-height: 1.2;
    font-weight: 500;
    padding-top: 5px;
  }

  .mobile-menu {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 100;
    box-shadow: 0 -2px 5px #eee;
    padding: 0 10px env(safe-area-inset-bottom);
    margin-bottom: 0 !important;
    background-color: white;

    .menu-tab {
      font-size: 0.8rem;
      width: auto;
      height: auto;
      padding: 5px;
      margin: 0;
    }

    .menu-text {
      font-size: 9px;
      height: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
